export interface PartTypeCategory {
  code: string;
  name: string;
}

export const PartTypeCategoriesKey = 'partTypeCategory';
